import React, { useEffect, useState, useContext } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import ItemRegistGridHeader from './ItemRegistGridHeader';
import ItemRegistGridBody from './ItemRegistGridBody';
import ItemRegistFooter from './ItemRegistFooter';
import { SettingsState } from '../../organisms/SelectSettings';
import { NAME_ITEM_SET, GetNameItemSetType, SetNameItemSetType } from './CollectSetting/CollectSettingDefine';
import { useModal } from '../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../App';

type ItemRegistProps = {
  editData: SettingsState;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 315px)',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

const cancelAction = () => {
  console.debug('saveAction');
};

const ItemRegist: React.FC<ItemRegistProps> = (props: ItemRegistProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [itemList, setItemList] = useState<NAME_ITEM_SET[]>([]);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const { login } = useContext(AppContext);

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('ItemRegist.はい', 'はい')}
      cancel={t('ItemRegist.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  useEffect(() => {
    getData();
    props.editData.SaveFunction = saveProc;
    props.editData.IsUpdate = false;
  }, [props.editData.CancelCondition]);
  /**
   * データ取得処理
   */
  const getData = () => {
    GetNameItemSetType().then((res) => {
      //console.debug(['useEffect GetNameItemSetType', res]);
      if (login.IsIoT) {
        //Iotの場合項目は7項目まで
        setItemList(res.slice(0, 7));
      } else {
        setItemList(res);
      }
    }).catch((e) => {
      setDlgmsg(t('ItemRegist.データ取得時にエラーが発生しました', 'データ取得時にエラーが発生しました'));
      actMsgDlg.open();
    });
  };

  const updateDev = (item: NAME_ITEM_SET) => {
    const idx = itemList.findIndex((srch) => srch.ITM_NAME_NO == item.ITM_NAME_NO);
    if (idx >= 0) {
      itemList[idx] = item;
      props.editData.Target = itemList;
      props.editData.IsUpdate = true;
    }
  };

  const saveAction = () => {
    setDlgmsg(t('ItemRegist.保存しますか?', '保存しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        saveProc(itemList);
      })
      .cancel(() => { });
  };
  const saveProc = (target: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const itemList = target as NAME_ITEM_SET[];
      itemList.forEach((r) => {
        if (r.ITM_NAME === '') {
          r.EST = 0;
        }
      });
      console.debug(['saveProc - ItemList', itemList]);
      if (itemList) {
        SetNameItemSetType(itemList).then(() => {
          props.editData.IsUpdate = false;
          // props.editData.CloseSetting();
          setItemList([]);
          getData();
          resolve('done');
        });
      } else {
        reject('data error');
      }
    });
  };

  const cancelAction = () => {
    if (props.editData.IsUpdate) {
      setDlgmsg(
        t(
          'ItemRegist.保存していないデータを破棄します。\nよろしいですか?',
          '保存していないデータを破棄します。\nよろしいですか?'
        )
      );
      actCfmDlg
        .open()
        .apply((_) => {
          // props.editData.IsUpdate = false;
          setItemList([]);
          props.editData.UpdateCancel();
          // props.editData.CloseSetting();
        })
        .cancel(() => { });
    } else {
      // props.editData.CloseSetting();
    }
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table aria-label="deviceName" stickyHeader size="small">
              <TableHead>
                <ItemRegistGridHeader />
              </TableHead>
              <TableBody>
                {itemList.map((dev, index) => {
                  return <ItemRegistGridBody item={dev} indexNo={index} updateItem={updateDev} />;
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <ItemRegistFooter onClickSaveButton={saveAction} onClickCancelButton={cancelAction}></ItemRegistFooter>
        </Grid>
      </Grid>
      {cfmdlg}
      {msgdlg}
    </>
  );
};

export default ItemRegist;
